import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Posts from './pages/Posts';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Auth from './pages/Auth';
import CMSPosts from './pages/CMS/Posts';
import CMSCategories from './pages/CMS/Categories';
import CMSProducts from './pages/CMS/Products';
import CMSSiteSettings from './pages/CMS/SiteSettings';
import CMSHome from './pages/CMS/Home';
import PostDetail from './pages/PostDetail';
import CMSNewsletter from './pages/CMS/Newsletter';
import CMSContactForm from './pages/CMS/ContactForm';
function App() {
  return (
    <HelmetProvider>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='*' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/auth' element={<Auth />} />
          <Route path='/blog' element={<Posts />} />
          <Route path='/blog/:id' element={<PostDetail />} />
          <Route path='/products' element={<Products />} />
          <Route path='/iletisim' element={<Contact />} />
          <Route path='/cms/posts' element={<CMSPosts />} />
          <Route path='/cms/categories' element={<CMSCategories />} />
          <Route path='/cms/products' element={<CMSProducts />} />
          <Route path='/cms/site-settings' element={<CMSSiteSettings />} />
          <Route path='/cms/newsletter' element={<CMSNewsletter />} />
          <Route path='/cms/contact-form' element={<CMSContactForm />} />
          <Route path='/cms/home' element={<CMSHome />} />
          <Route path='/cms/' element={<CMSHome />} />
        </Routes>
    </HelmetProvider>
  );
}

export default React.memo(App);
